import React, { Component, Fragment } from 'react'
import { Icon } from '@driftt/tide'
import DnDTable from 'components/DnDTable'
import { connect } from 'react-redux'

import { bindActionCreators } from 'redux'
import { setArticle, clearArticle, reorderSectionDocuments } from 'modules/knowledgebase/actions'

import DeleteArticleContent from 'components/DeleteModalContent/DeleteArticleContent'
import EmptyTable from 'components/EmptyTable'

import { getArticle, getSection } from 'modules/knowledgebase/selectors'
import RowFormatter from 'constants/Table/rowFormatter'

import { TABLE_TYPE_SECTION } from '../EmptyTable/constants'
import { SectionArticleColumns } from 'constants/Table'

import './style.css'

class Section extends Component {
  state = {
    isModalOpen: false
  }
  
  handleDeleteArticle = article => () => {
    const { actions } = this.props
    actions.setArticle(article)
  
    this.setState({isModalOpen: true})
  }
  
  handleCloseModal = () => {
    const { actions } = this.props
    
    this.setState({isModalOpen: false})
    actions.clearArticle()
  }
  
  getData = () =>
    this.props.section.documents.map(
      article => RowFormatter
      .ArticleTableRows(article, this.handleDeleteArticle)
  )
  
  handleSectionArticleDragEnd = dropResult => {
    const { actions, section } = this.props
  
    if (!!dropResult.destination) {
      const event = {
        categoryId: section.categoryId,
        sectionId: section.id,
        sourceId: dropResult.draggableId,
        destinationId: section.documents[dropResult.destination.index].id,
        oldIndex: dropResult.source.index,
        newIndex: dropResult.destination.index
      }
  
      actions.reorderSectionDocuments(event)
    }
  }
  
  render() {
    const { section } = this.props
    const { isModalOpen } = this.state
    const hasNoArticles = section ? section.documents.length === 0 : false
    return section ? (
      <div className="section-articles-table">
        <div className="section-name-and-description-wrapper">
          <Icon name="section-2"/>
          <h2 className="category-section-name">{section.name}</h2>
          {section.description.length > 0 &&
            <Fragment>
              <h3 className="category-section-description">{`Section description: ${section.description}`}</h3>
              <hr className="category-hr"/>
            </Fragment>
          }
        </div>
        <div className="category-section-tables-articles-wrapper">
          <DnDTable
            isDraggable
            draggableObjects={section.documents}
            className="category-section-table-articles"
            columns={SectionArticleColumns}
            data={this.getData()}
            onDragEnd={this.handleSectionArticleDragEnd}
          />
        </div>
  
        {hasNoArticles && <EmptyTable {...this.props} tableType={TABLE_TYPE_SECTION}/>}
        {isModalOpen && <DeleteArticleContent onCloseModal={this.handleCloseModal} isOpen={isModalOpen} />}
      </div>
    ) : null
  }
}

const mapStateToProps = (state, props) => ({
  section: getSection(state, { sectionId: parseInt(props.match.params.sectionId, 10) }),
  article: getArticle(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    reorderSectionDocuments,
    setArticle,
    clearArticle
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Section)